import Vue from 'vue'
import store from '../store/index'

/**权限指令**/
const has = Vue.directive('allow', {
  bind: function (el, binding, vnode) {
    let permissionKey = vnode.context.$route.meta.code
    // 获取页面按钮权限
    let btnPermissionsArr = store.getters['userInfo/btnPermissions'] || []
    let operationAll = permissionKey + ":*"
    if (binding.value.constructor === String) {
      binding.value = [binding.value]
    }
    let arr = binding.value.filter(key => {
      let operation = permissionKey + ":" + binding.value
      if (btnPermissionsArr.indexOf(operationAll) >= 0 || btnPermissionsArr.indexOf(operation) >= 0) {
        return true
      }
    })
    if (arr == undefined || arr.length == 0) el.style.display = 'none'
  },
})
export { has }